import DeskOutputCardView from './DeskOutputCardView.html';
import './deskOutputCard.scss';
import { TicketStatus } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/TicketStatus';
import { ValueSource } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/Condition';
import { CreateTicketStatus } from '../../../../models/CreateTicketStatus';
import { DESK_TICKET_STATUS_VARIABLE, FORWARD_TO_DESK_STATUS_VARIABLE } from '../../../../services/BuilderStateService';
class DeskOutputCard {
    static $inject = ['$translate', '$attrs'];
    constructor($translate, $attrs) {
        'ngInject';
        this.$translate = $translate;
        this.hasRemoveButton = $attrs.onRemove ? true : false;
    }
    $onInit() {
        const baseUrl = this.application?.isSubflow ? `../../../${this.application?.callerApplication.shortName}` : '../..';
        this.availableStatus = [
            {
                value: TicketStatus.ClosedAttendant,
                label: this.$translate.instant('builder-tabs-outputs.ticketStatus.closedAttendant'),
            },
            {
                value: TicketStatus.ClosedClient,
                label: this.$translate.instant('builder-tabs-outputs.ticketStatus.closedClient'),
            },
            {
                value: TicketStatus.ClosedClientInactivity,
                label: this.$translate.instant('builder-tabs-outputs.ticketStatus.closedClientInactivity.label'),
                info: this.$translate.instant('builder-tabs-outputs.ticketStatus.closedClientInactivity.info', { baseUrl: baseUrl }),
            },
            {
                value: TicketStatus.Waiting,
                label: this.$translate.instant('builder-tabs-outputs.ticketStatus.waiting'),
            },
            {
                value: CreateTicketStatus.NoAgentAvailable,
                label: this.$translate.instant('builder-tabs-outputs.deskAttendantAvailability.outputConditionLabel'),
                info: this.$translate.instant('builder-tabs-outputs.deskAttendantAvailability.info', { baseUrl: baseUrl }),
            },
            {
                value: CreateTicketStatus.OutOfAttendanceHour,
                label: this.$translate.instant('builder-tabs-outputs.deskOutOfAttendanceHour.outputConditionLabel'),
                info: this.$translate.instant('builder-tabs-outputs.deskOutOfAttendanceHour.info', { baseUrl: baseUrl }),
            },
        ];
        this.condition = this.output.conditions.find(c => c.source == ValueSource.Context
            && (c.variable == FORWARD_TO_DESK_STATUS_VARIABLE || c.variable == DESK_TICKET_STATUS_VARIABLE));
        const status = this.condition.values[0];
        this.selectedStatus = this.availableStatus.find(s => s.value == status);
    }
    addNewState($data) {
        $data.output = this.output;
        $data.state = this.state;
        this.onAddNewState({ $data });
    }
    addNewSurvey($data) {
        $data.output = this.output;
        $data.state = this.state;
        this.onAddNewSurvey({ $data });
    }
    changeOutputState($data) {
        $data.output = this.output;
        this.outputChanged({ $data });
    }
    toggleInfo() {
        this.showInfo = !this.showInfo;
    }
}
DeskOutputCard.$inject = ['$translate', '$attrs'];
export const DeskOutputCardComponent = {
    controller: DeskOutputCard,
    controllerAs: '$ctrl',
    template: DeskOutputCardView,
    bindings: {
        output: '<',
        outputChanged: '&',
        states: '<',
        state: '<',
        application: '<',
        onRemove: '&',
        onAddNewState: '&?',
        onAddNewSurvey: '&?',
        showSwitchSurvey: '<',
    },
};
